// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mc-icon-box-x[data-v-1671e544]{width:40%;position:absolute;z-index:70;top:32px;left:calc(30% - 3px)}.mc-icon-box-y[data-v-1671e544]{padding-top:100%;width:100%;border-radius:50%;border:3px solid #fff;background-size:cover}", ""]);
// Exports
module.exports = exports;
